import React from 'react';
import { Points } from 'components/Points/Points';
import './CardGroupHeaderResponsive.css';

interface CardGroupHeaderResponsiveProps {
  title: string;
  lowPrice?: number;
  highPrice?: number;
  totalValue?: number;         // For Send Cards page
  autoMatch?: boolean;         // For Send Cards page
  onAutoMatchToggle?: (val: boolean) => void;
  autoMatchDisabled?: boolean; // When global auto-match is on
  matchingCardCount?: number;  // For auto-match count display
  totalCardCount?: number;     // For auto-match count display
  mode?: 'printings' | 'send'; // Determines which header to render
}

const CardGroupHeaderResponsive: React.FC<CardGroupHeaderResponsiveProps> = ({
  title,
  lowPrice,
  highPrice,
  totalValue,
  autoMatch = false,
  onAutoMatchToggle,
  autoMatchDisabled = false,
  matchingCardCount,
  totalCardCount,
  mode = 'printings',
}) => {
  return (
    <div className="card-group-header-responsive">
      {/* Mobile: Hide title on mobile since it's shown in user info bar */}
      <span className="header-title-responsive header-title-desktop-only">{title}</span>

      {mode === 'printings' && (
        <div className="header-prices-responsive">
          <div className="price-item-responsive">
            <span className="price-label-responsive">Low</span>
            <Points points={lowPrice || 0} type="small" />
          </div>
          <div className="price-item-responsive">
            <span className="price-label-responsive">High</span>
            <Points points={highPrice || 0} type="small" />
          </div>
        </div>
      )}

      {mode === 'send' && (
        <div className="header-prices-responsive">
          {/* Desktop: Show Auto-Match toggle */}
          <div className={`price-item-responsive auto-match-container-desktop ${autoMatchDisabled ? 'disabled' : ''}`}>
            <span className="price-label-responsive">
              &#9889; Auto-Match
              {matchingCardCount !== undefined && totalCardCount !== undefined && (
                <span className="auto-match-count-desktop">
                  ({matchingCardCount}/{totalCardCount})
                </span>
              )}
            </span>
            <label className="auto-match-toggle-desktop">
              <input
                type="checkbox"
                checked={autoMatch}
                onChange={(e) => onAutoMatchToggle?.(e.target.checked)}
                disabled={autoMatchDisabled}
              />
              <span className={`toggle-slider-desktop ${autoMatchDisabled ? 'forced-on' : ''}`} />
            </label>
          </div>
          <div className="price-item-responsive">
            <Points points={totalValue || 0} type="small" />
          </div>
        </div>
      )}
    </div>
  );
};

export default CardGroupHeaderResponsive;
